<template>
  <audio ref="audioRef" controls hidden>
    <source src="@/assets/sounds/s08.mp3" type="audio/mpeg" />
  </audio>
</template>
<script>
export default {
  name: "Audio",
  data() {
    return {};
  },
  computed: {
    timer() {
      return this.$store.getters["app/timer"];
    },
    isNotice() {
      return this.$store.getters["app/isNotice"];
    },
  },
  watch: {
    timer(val) {
      if (val > 0 && this.isNotice) {
        this.playAudio();
      }
    },
    isNotice(newVal) {
      if (newVal && this.$refs.audioRef) {
        this.playAudio();
      }
    },
  },
  methods: {
    playAudio() {
      this.$refs.audioRef
        .play()
        .then(() => {
          this.$store.commit("app/SHOW_BEEP", false);
          console.log("音效已播放");
        })
        .catch((err) => {
          console.error("音效播放失敗:", err);
        });
    },
  },
  mounted() {
    this.playAudio();
    // 啟動倒數計時
    this.$store.dispatch("app/countdown");
    this.$emit("mounted", this.$refs.audioRef);
  },

  beforeDestroy() {
    // 組件銷毀時停止計時器
    this.$store.dispatch("app/stopCountdown");
  },
};
</script>
<style lang="scss" scoped></style>
